import { jsx as a, jsxs as p } from "react/jsx-runtime";
import * as r from "@radix-ui/react-dialog";
import { X as g } from "lucide-react";
import { forwardRef as s } from "react";
const m = {
  sm: 360,
  md: 440,
  lg: 540
}, D = r.Root, C = r.Trigger, j = r.Portal, k = r.Close, z = r.Root, x = s(function({ className: e, style: o, ...t }, n) {
  return /* @__PURE__ */ a(
    r.Overlay,
    {
      ref: n,
      className: ["ls-drawer-overlay", e].filter(Boolean).join(" "),
      style: {
        position: "fixed",
        inset: 0,
        backgroundColor: "var(--scrim-drawer)",
        zIndex: "var(--z-drawer)",
        ...o
      },
      ...t
    }
  );
}), B = s(function({ className: e, width: o = "md", side: t = "right", style: n, children: d, ...c }, f) {
  const i = t === "right";
  return /* @__PURE__ */ p(r.Portal, { children: [
    /* @__PURE__ */ a(x, {}),
    /* @__PURE__ */ a(
      r.Content,
      {
        ref: f,
        className: ["ls-drawer-content", e].filter(Boolean).join(" "),
        style: {
          position: "fixed",
          top: 0,
          bottom: 0,
          [i ? "right" : "left"]: 0,
          width: m[o],
          maxWidth: "100vw",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "var(--bg-surface)",
          borderLeft: i ? "1px solid var(--border-strong)" : "none",
          borderRight: i ? "none" : "1px solid var(--border-strong)",
          boxShadow: i ? "var(--shadow-drawer-right)" : "12px 0 32px rgba(0, 0, 0, 0.3)",
          color: "var(--text-primary)",
          zIndex: "var(--z-drawer)",
          ...n
        },
        ...c,
        children: d
      }
    )
  ] });
}), S = s(function({ title: e, description: o, onClose: t, showClose: n = !0, className: d, style: c, children: f, ...i }, v) {
  return /* @__PURE__ */ p(
    "div",
    {
      ref: v,
      className: ["ls-drawer-header", d].filter(Boolean).join(" "),
      style: {
        padding: "var(--space-5) var(--space-6)",
        borderBottom: "1px solid var(--border-subtle)",
        display: "flex",
        alignItems: "flex-start",
        gap: "var(--space-4)",
        flexShrink: 0,
        ...c
      },
      ...i,
      children: [
        /* @__PURE__ */ p("div", { style: { flex: 1, minWidth: 0 }, children: [
          e ? /* @__PURE__ */ a(
            r.Title,
            {
              style: {
                margin: 0,
                fontSize: "var(--text-lg)",
                fontWeight: "var(--font-weight-semibold)",
                color: "var(--text-primary)"
              },
              children: e
            }
          ) : null,
          o ? /* @__PURE__ */ a(
            r.Description,
            {
              style: {
                margin: 0,
                marginTop: "var(--space-1)",
                fontSize: "var(--text-sm)",
                color: "var(--text-secondary)"
              },
              children: o
            }
          ) : null,
          f
        ] }),
        n ? /* @__PURE__ */ a(r.Close, { asChild: !0, children: /* @__PURE__ */ a(
          "button",
          {
            type: "button",
            "aria-label": "Close",
            onClick: t,
            style: {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: "var(--radius-md)",
              border: "1px solid transparent",
              background: "transparent",
              color: "var(--text-secondary)",
              cursor: "pointer"
            },
            children: /* @__PURE__ */ a(g, { size: 16, "aria-hidden": "true" })
          }
        ) }) : null
      ]
    }
  );
}), w = {
  padding: "var(--space-6)",
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  fontSize: "var(--text-sm)",
  color: "var(--text-primary)"
}, T = s(
  function({ className: e, style: o, ...t }, n) {
    return /* @__PURE__ */ a(
      "div",
      {
        ref: n,
        className: ["ls-drawer-body", e].filter(Boolean).join(" "),
        style: { ...w, ...o },
        ...t
      }
    );
  }
), u = {
  padding: "var(--space-4) var(--space-6)",
  borderTop: "1px solid var(--border-subtle)",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "var(--space-2)",
  flexShrink: 0,
  background: "var(--bg-surface)"
}, R = s(
  function({ className: e, style: o, ...t }, n) {
    return /* @__PURE__ */ a(
      "div",
      {
        ref: n,
        className: ["ls-drawer-footer", e].filter(Boolean).join(" "),
        style: { ...u, ...o },
        ...t
      }
    );
  }
), I = r.Title, N = r.Description;
export {
  z as D,
  T as a,
  k as b,
  B as c,
  N as d,
  R as e,
  S as f,
  x as g,
  j as h,
  D as i,
  I as j,
  C as k
};
//# sourceMappingURL=Drawer-oTTotTjV.js.map
